import { some, isInteger, compact } from "lodash";
import { barChartHeight } from "./barChartHeight";
import renderChart from "./renderChart";

export const barChartConfig = (data, options) => {
  const dataEntries = Object.entries(data);

  if (options.sortByValue) {
    dataEntries.sort(([, firstValue], [, secondValue]) => secondValue - firstValue);
  }

  const seriesData = dataEntries.map(([, value]) => value);
  const allowDecimals = some(compact(seriesData), value => !isInteger(value));

  return {
    chart: {
      type: "bar",
      height: barChartHeight(dataEntries.length)
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    xAxis: {
      categories: dataEntries.map(([label]) => label)
    },
    yAxis: {
      allowDecimals,
      title: {
        text: options.label
      }
    },
    plotOptions: {
      bar: {
        dataLabels: {
          align: "right",
          enabled: options.showValues,
          inside: true,
          formatter: function () {
            return this.y > 0 ? this.y : null;
          },
          style: {
            color: "contrast"
          }
        }
      }
    },
    series: [
      {
        name: options.label,
        data: seriesData
      }
    ]
  };
};

const barChart = (element, data, options) => {
  return renderChart(element, barChartConfig(data, options), options);
};

export default barChart;
